import type { ReactElement } from 'react';

import { HighlightText } from '@bestseller-bit/frontend-community.components.highlight-text';
import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface MaterialInformationProps {
    /** Will be displayed as header, content serves as categorization */
    headerText?: string;
    /** Will be displayed as the main text, content serves as identifier */
    nameText?: string;
    /** Will be displayed as a caption, content serves as composition breakdown */
    detailText?: string;
    /** The search query to highlight in the text fields */
    highlight?: string;
}

export const MaterialInformation = ({
    headerText,
    nameText,
    detailText,
    highlight = '',
}: MaterialInformationProps): ReactElement => {
    const { palette } = useTheme();

    return (
        <Stack
            sx={{
                justifyContent: 'center',
                px: 3,
                py: 2,
                textWrap: 'wrap',
                minWidth: 0,
                overflowWrap: 'break-word',
            }}
        >
            {headerText && (
                <Typography
                    variant="buttons.table"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {headerText}
                </Typography>
            )}
            {nameText && (
                <Typography variant="captions.default">
                    <HighlightText
                        text={nameText}
                        highlight={highlight}
                    />
                </Typography>
            )}
            {detailText && (
                <Typography
                    variant="captionsSmall.default"
                    sx={{ color: alpha(palette.text.primary, 0.7) }}
                >
                    <HighlightText
                        text={detailText}
                        highlight={highlight}
                    />
                </Typography>
            )}
        </Stack>
    );
};
